let initialState = {

}

const editPortletDataReducer = (state = initialState, action) => {

  switch (action.type) {
    case 'SET_EDIT_PORTLET_DATA':
      return {
        ...state,
        ...action.data
      };
      default:
        return state
  }
}

export default editPortletDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/EditPortletDataReducer.js